import React, { Component } from 'react'
import { AssignmentsView } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as assignmentsViewActionCreators from '../../redux/modules/assignmentsView'
import { db } from '../../config/firebaseconfig'
import getUserAssignments from '../../helpers/getUserAssignments'

class AssignmentsViewContainer extends Component {

  componentDidMount() {
    if (this.props.activeUserId) {
      this.props.fetchingAssignments()
      db.collection('assignments').get()
        .then( (querySnapshot) => {
          let assignments = {}
          querySnapshot.forEach( (doc) => {
            const docData = doc.data()
            assignments[docData.assignmentId] = docData
          })
          this.props.fetchingAssignmentsSuccess(assignments)
          getUserAssignments(
            assignments,
            this.props.activeUserId,
            this.props.activeUser,
            {
              fetchingUserAssignments: this.props.fetchingUserAssignments,
              fetchingUserAssignmentsSuccess: this.props.fetchingUserAssignmentsSuccess,
              fetchingUserAssignmentsError: this.props.fetchingUserAssignmentsError,
            }
          )
        })
        // Fetch userAssignments and create any that haven't been made yet
/*        this.props.fetchingUserAssignments()
        db.collection('userAssignments').doc(this.props.activeUserId).get()
          .then( (doc) => {
            let userAssignments = {}
            const storedUserAssignments = doc.data()
            const assignmentIds = Object.keys(assignments)
            assignmentIds.forEach( (assignmentId) => {
              if (storedUserAssignments[assignmentId]) {
                //  copy userAssignment from store
                userAssignments[assignmentId] = storedUserAssignments[assignmentId]
              } else {
                // create new userAssignment in store and display
                userAssignments[assignmentId] = {
                  userId: this.props.activeUserId,
                  assignmentId,
                  userAssignmentId: uuid(),
                  activity: null,
                  grade: null,
                }
                db.collection('userAssignments').doc(this.props.activeUserId).set({
                  [assignmentId]: userAssignments[assignmentId],
                })
              }
            })
            this.props.fetchingUserAssignmentsSuccess(userAssignments)
          })
          .catch( (err) => this.props.fetchingUserAssignmentsError(err))
        }) */
        .catch( (err) => this.props.fetchingAssignmentsError(err) )

    }
  }

  
  
  render() {
    return (
      <AssignmentsView 
        assignments={this.props.assignments}
        activeAssignment={this.props.activeAssignment}
        isFetchingAssignments={this.props.isFetchingAssignments}
        error={this.props.error}
        activeUserId={this.props.activeUserId}
        activeUserAssignments={this.props.activeUserAssignments}
        openAssignment={this.props.openAssignment}
      />
    )
  }
}

export default connect(
  (state) => ({
    assignments: state.assignmentsView.assignments,
    activeAssignment: state.assignmentsView.activeAssignment,
    isFetchingAssignments: state.assignmentsView.isFetchingAssignments,
    error: state.assignmentsView.error,
    activeUserId: state.users.uid,
    activeUser: state.users.activeUser,
    activeUserAssignments: state.assignmentsView.activeUserAssignments,
  }),
  (dispatch) => bindActionCreators(assignmentsViewActionCreators, dispatch)
)(AssignmentsViewContainer)


// WEBPACK FOOTER //
// ./src/containers/Assignments/AssignmentsViewContainer.js